import React from 'react'

import { SimpleCollapse, Row, Input, Span, Button } from 'components'
import { SPACING, COLORS } from 'utils'

export interface IDestinatario {
  id: string
  txEmailDestinatario: string
  nmDestinatario: string
  idJobEmail?: number
}

interface IDestinatariosProps {
  errors: any
  handleDelete: any
  handleNewItem: any
  emails: IDestinatario[]
  isConsult: boolean
  handleCleanDestinatarios: any
  handleChangeDestinatario: (
    _event: React.ChangeEvent<HTMLInputElement>
  ) => void
}

const Destinatarios: React.FC<IDestinatariosProps> = ({
  errors,
  handleNewItem,
  handleDelete,
  emails,
  isConsult,
  handleChangeDestinatario,
  handleCleanDestinatarios
}) => {
  return (
    <SimpleCollapse title="Destinatários">
      {emails.map((item, index) => {
        return (
          <Row
            marginBottom={SPACING.spacing10}
            key={item.id}
            alignItems="center"
            justifyContent="start"
          >
            <Input
              customError={
                errors &&
                errors['destinatarios'] &&
                errors['destinatarios'][index]
                  ? errors['destinatarios'][index]?.nmDestinatario
                  : null
              }
              formValue={`${index}.nmDestinatario`}
              onChange={handleChangeDestinatario}
              label="Nome do Grupo"
              placeholder="Nome do Grupo"
              width="20em"
              value={item.nmDestinatario}
              disabled={isConsult}
            />
            <Input
              customError={
                errors &&
                errors['destinatarios'] &&
                errors['destinatarios'][index]
                  ? errors['destinatarios'][index]?.txEmailDestinatario
                  : null
              }
              value={item.txEmailDestinatario}
              formValue={`${index}.txEmailDestinatario`}
              onChange={handleChangeDestinatario}
              label="E-mail do Grupo"
              placeholder="Endereço de E-mail do Grupo"
              marginLeft={SPACING.spacing10}
              marginRight={SPACING.spacing10}
              width="25em"
              disabled={isConsult}
            />

            <Button text="+" onClick={handleNewItem} disabled={isConsult} />
            {index > 0 && (
              <Button
                marginLeft={SPACING.spacing10}
                text="-"
                onClick={() => handleDelete(item.id)}
                disabled={isConsult}
              />
            )}
          </Row>
        )
      })}

      {errors && errors['destinatarios'] && (
        <Span color={COLORS.error} text={errors['destinatarios'].message} />
      )}
      <Row alignItems="center" justifyContent="end">
        <Button
          text="Limpar"
          onClick={handleCleanDestinatarios}
          variantButton="text"
          disabled={isConsult}
        />
      </Row>
    </SimpleCollapse>
  )
}

export default Destinatarios
